"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_TRANSLATIONS = void 0;
/**
 * Common actions
 *
 */
const SET_TRANSLATIONS = exports.SET_TRANSLATIONS = 'SET_TRANSLATIONS';